module.exports = __webpack_public_path__ + "static/img/redeem-mfood.a609aabc.png";